const styles = {
  cardContainer: {
    minWidth: 'auto',
    maxWidth: '100%',
  },
};

export default styles;
